import React from 'react';
import { connect } from 'react-redux';

import TableTabIcon from '@mui/icons-material/TableChart';
import DashboardIcon from '@mui/icons-material/Dashboard';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

import { ButtonBase, Tooltip } from '@mui/material';

import { withStyles } from '@mui/styles';
import CommonStyles from '../../../common/CommonStyles';
import JelsStyles from '../JelsStyles';

import { jelTypes } from '../../../constants';

const styles = {
  ...CommonStyles,
  ...JelsStyles,
};

export default connect((state) => ({ jels: state.jels, accounts_tbox: state.meta.accounts_tbox }))(
  withStyles(styles)(({ viewData, jels, accounts_tbox, classes, openViewInNewTab, toggleEditModal, toggleEditDashboardModal }) => (
    <Tooltip
      id={`${viewData.id}`}
      title={`
        ${viewData && viewData.type && viewData.type === jelTypes.form
          ? 'Form edit'
          : viewData && viewData.type && viewData.type === jelTypes.table
          ? 'Table edit'
          : 'Dashboard edit'}` + `${openViewInNewTab ? ' in new tab' : ''}`
        
      }
      placement="top"
      classes={{
        tooltip: classes.muiTooltip,
      }}
      style={{ pointerEvents: (toggleEditModal || openViewInNewTab) ? '' : 'none' }}
    >
      <ButtonBase
        className={`jel-btn ${classes.jelBtn} ${classes.jel}`}
        onClick={(e) => {
          if (openViewInNewTab) {
            window.open(`http://${window.location.host}/ui_edit?tab=${viewData.type}&id=${viewData.id}`, "_blank")
          } else {
            const openJel = e.currentTarget.querySelector('.open-jel-icon-toggle');
            if (openJel && openJel.contains(e.target)) return;

            if (viewData.type === jelTypes.table || viewData.type === jelTypes.form) {
              toggleEditModal({
                isOpened: true,
                data: jels.jelData[viewData.id],
                type: viewData.type
              });
            } else if (viewData.type === jelTypes.dashboard){
              toggleEditDashboardModal({
                concept: accounts_tbox && accounts_tbox.nodes[viewData.acc_concept],
                isOpened: true,
                dashboard: jels.jelData[viewData.id],
                type: viewData.type
              });
            }
          }
        }}
      >
        {viewData.type === jelTypes.form ? (
          <img
            src="/images/ui-edit-frm.svg"
            alt="ui-edit-frm"
            style={{
              width: '12px',
              height: '12px',
              margin: '0 8px 0 3px',
            }}
          />
        ) : viewData.type === jelTypes.table ? (
          <TableTabIcon className={classes.jelIcon} style={{ color: '#DE3939' }} />
        ) : (
          <DashboardIcon className={classes.jelIcon} style={{ color: '#8F24B7' }} />
        )}

        <span className={classes.jelTitle}>
          {viewData && viewData.title ? `${viewData.title}`
            : viewData && viewData.acc_concept && accounts_tbox && accounts_tbox.nodes && accounts_tbox.nodes[viewData.acc_concept]
            ? `${viewData.id} ${accounts_tbox.nodes[viewData.acc_concept].title}`
              : ''
          }
        </span>

        {toggleEditDashboardModal && viewData.type !== jelTypes.dashboard ? (
          <div
            className={`open-jel-icon-toggle ${classes.openJelIcon}`}
            onMouseEnter={() => {
              const tooltip = document.getElementById('tooltipUsedIn');
              if (tooltip) tooltip.hidden = true;
            }}
            onMouseLeave={() => {
              const tooltip = document.getElementById('tooltipUsedIn');
              if (tooltip) tooltip.hidden = false;
            }}
          >
            <Tooltip
              placement="top"
              title={`Open ${viewData.title} in new tab`}
              classes={{
                tooltip: classes.muiTooltip
              }}
            >
              <a target="_blank" rel="noreferrer" href={`/frm?id=${viewData.id}`} style={{ display: 'flex' }}>
                <OpenInNewIcon className={classes.tableRowBtn} style={{ fontSize: 18 }}/>
              </a>
            </Tooltip>
          </div>
        ) : null}
      </ButtonBase>
    </Tooltip>
    )
  )
);
